import ReceptionDayData, { IReceptionDayData } from "@/types/clients/esquire/data/general/reception-day-data";

export interface IReceptionCheckInOutData {
  fri: IReceptionDayData;
  mon: IReceptionDayData;
  sat: IReceptionDayData;
  sun: IReceptionDayData;
  thu: IReceptionDayData;
  tue: IReceptionDayData;
  wed: IReceptionDayData;
}

export default class ReceptionCheckInOutData {
  public fri: ReceptionDayData;
  public mon: ReceptionDayData;
  public sat: ReceptionDayData;
  public sun: ReceptionDayData;
  public thu: ReceptionDayData;
  public tue: ReceptionDayData;
  public wed: ReceptionDayData;

  constructor(data: IReceptionCheckInOutData) {
    this.fri = new ReceptionDayData(data.fri);
    this.mon = new ReceptionDayData(data.mon);
    this.sat = new ReceptionDayData(data.sat);
    this.sun = new ReceptionDayData(data.sun);
    this.thu = new ReceptionDayData(data.thu);
    this.tue = new ReceptionDayData(data.tue);
    this.wed = new ReceptionDayData(data.wed);
  }

  toDTO(): IReceptionCheckInOutData {
    return {
      mon: this.mon.toDTO(),
      tue: this.tue.toDTO(),
      wed: this.wed.toDTO(),
      thu: this.thu.toDTO(),
      fri: this.fri.toDTO(),
      sat: this.sat.toDTO(),
      sun: this.sun.toDTO()
    };
  }
}
